import { makeAutoObservable } from 'mobx';
import { DEFAULT_FPS } from 'modules/Canvas/components/VideoControls/helpers';

export interface MediaPlayback {
  currentFrame: number | null;
  fps: number;
  setCurrentFrame: (n: number) => void;
  setFps: (n: number) => void;
  currentTimeInSeconds: number;
}

export const makeMediaPlayback = (): MediaPlayback => {
  const playback: MediaPlayback = {
    currentFrame: null,
    fps: DEFAULT_FPS,
    setCurrentFrame(frame: number | null) {
      playback.currentFrame = frame;
    },
    setFps(fps: number) {
      playback.fps = fps;
    },
    get currentTimeInSeconds() {
      return Math.floor((playback.currentFrame || 0) / playback.fps);
    },
  };
  return makeAutoObservable(playback, undefined, { autoBind: true });
};
